import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'

import { Container, Row, Col,Table, Tab, Nav } from 'react-bootstrap';
import LeftPanel from '../Programmes/LeftPanel'

function Main() {
    return(
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Research"/>
            <section className="project-detail">
                <div className='container'>
                <div className="c-heading">
                        <h3>Research Projects</h3>
                        </div>
                    <Row>
                    <Col md={12} className='c-left custom-padding-color'>
                        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                            <Row>
                                <Col sm={3}>
                                <Nav variant="pills" className="flex-column">
                                    <Nav.Item>
                                    <Nav.Link eventKey="first">Sponsored Projects</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                    <Nav.Link eventKey="second">Project of Eminence</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                                </Col>
                                <Col sm={9}>
                                <Tab.Content>
                                    <Tab.Pane eventKey="first">                
                                        
                                    <table className="table table-striped">
					<tbody><tr>
						<td ><b>S.No</b></td>
						<td ><b>Year</b></td>
						<td ><b>Title</b></td>
						<td ><b>Duration of Project(Years)</b></td>
						<td ><b>Funding Agency</b></td>
					</tr>
					<tr>
						<td >1</td>
						<td >2017-2018</td>
						<td >High throughput materials modeling for efficient optoelectronics and charge transport applications; towards better solar cells</td>
						<td >5</td>
						<td >Department of Science and Technology</td>
					</tr>
					<tr>
						<td >2</td>
						<td >2017-2018</td>
						<td >Force identification in existing structures</td>
						<td >5</td>
						<td >Department of Science and Technology</td>
					</tr>
					<tr>
						<td >3</td>
						<td >2017-2018</td>
						<td >Structure intergrated sensors and actuators to monitor and renew machine tool performance</td>
						<td >3</td>
						<td >Ministry of Human Resource Development</td>
					</tr>
					<tr>
						<td >4</td>
						<td >2017-2018</td>
						<td >Design, development and demonstration of indigenous hydrogen storage and fuel cell system for mobile and stationary applications of 5 KW capacity</td>
						<td >3</td>
						<td >Ministry of Human Resource Development</td>
					</tr>
					<tr>
						<td >5</td>
						<td >2017-2018</td>
						<td >Reversible alkali metal based hybrides for High Temperature Thermal Energy Storage</td>
						<td >2</td>
						<td >Department of Science and Technology</td>
					</tr>
					<tr>
						<td >6</td>
						<td >2017-2018</td>
						<td >Thermal-metallurgical-mechanical modeling of single and multi-wire deposition welding process using finite element method as well as CFD-FEM framework</td>
						<td >5</td>
						<td >Department of Science and Technology</td>
					</tr>
					<tr>
						<td >7</td>
						<td >2017-2018</td>
						<td >NPTL-DTH SWAYAMA Prabha</td>
						<td >3</td>
						<td >Ministry of Human Resource Development</td>
					</tr>
					<tr>
						<td >8</td>
						<td >2017-2018</td>
						<td >Lambert W and Polylogarithm Operations in Theoretical and Applied Physics</td>
						<td >2</td>
						<td >Shastri Indo Canadian Institute</td>
					</tr>
					<tr>
						<td >9</td>
						<td >2017-2018</td>
						<td >Enhancing QoS in Mobile Edge Computing Environments</td>
						<td >1</td>
						<td >Shastri Indo Canadian Institute</td>
					</tr>
					<tr>
						<td >10</td>
						<td >2018-2019</td>
						<td >Ab Initio Modeling of Defects in Nanoscale Materials</td>
						<td >3</td>
						<td >Department of Science and Technology</td>
					</tr>
					<tr>
						<td >11</td>
						<td >2018-2019</td>
						<td >Investigation on stochastic thermodynamics of entropic information: Aimining to beat the Landauer's limit</td>
						<td >3</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >12</td>
						<td >2018-2019</td>
						<td >A Date - intensive groundwater modelling approach for evaluating sustainability of groundwater use</td>
						<td >3</td>
						<td >Department of Science and Technology</td>
					</tr>
					<tr>
						<td >13</td>
						<td >2018-2019</td>
						<td >Centre for Sustainable treatment, reuse and management for Efficient, Affordable and Synergistic solutions for water (Water-IC for SUTRAM of EASY WATER)</td>
						<td >5</td>
						<td >Department of Science and Technology</td>
					</tr>
					<tr>
						<td >14</td>
						<td >2018-2019</td>
						<td >Algorithms for smart grids - INSPIRE</td>
						<td >5</td>
						<td >Department of Science and Technology</td>
					</tr>
					<tr>
						<td >15</td>
						<td >2018-2019</td>
						<td >Role of Institutions, Incentive and Information in Enhancing Climate Resilient Agricultural Interventions and their Impact Across States in India</td>
						<td >2</td>
						<td >Indian Council of Social Science Research-ICSSR</td>
					</tr>
					<tr>
						<td >16</td>
						<td >2018-2019</td>
						<td >Wave propagation by small inhomogeneities : Applications to medical Imaging, Effective medium theory and theory of Meta-materials</td>
						<td >3</td>
						<td >Department of Science and Technology</td>
					</tr>
					<tr>
						<td >17</td>
						<td >2018-2019</td>
						<td >Points on Elliptic curve over finite fields - INSPIRE Faculty Award</td>
						<td >5</td>
						<td >Department of Science and Technology</td>
					</tr>
					<tr>
						<td >18</td>
						<td >2018-2019</td>
						<td >Investigation of Novel Quantum Spin Liquids &amp; Multiferroics in Geometrically Frustrated Systems</td>
						<td >5</td>
						<td >Department of Science and Technology</td>
					</tr>
					<tr>
						<td >19</td>
						<td >2018-2019</td>
						<td >Nanomaterials based active and intelligent packaging of selected baked, fermented and fried foods</td>
						<td >3</td>
						<td >Department of Biotechnology-Ministry of science and technology</td>
					</tr>
					<tr>
						<td >20</td>
						<td >2018-2019</td>
						<td >Lattice effects in strongly correlated electron systems</td>
						<td >3</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >21</td>
						<td >2018-2019</td>
						<td >Synthesis and characterisation of composite thermochemical energy storage materials for solar thermal applications</td>
						<td >3</td>
						<td >Department of Science and Technology</td>
					</tr>
					<tr>
						<td >22</td>
						<td >2018-2019</td>
						<td >Narrow gap welding of 12 mm thick naval steel using tandem gas metal arc welding process</td>
						<td >2</td>
						<td >Naval Research Board</td>
					</tr>
					<tr>
						<td >23</td>
						<td >2019-2020</td>
						<td >DST-IIT Bombay Energy Storage Platform on Hydrogen</td>
						<td >5</td>
						<td >Department of Science and Technology</td>
					</tr>
					<tr>
						<td >24</td>
						<td >2019-2020</td>
						<td >Hybrid Mechanical Vapor Compression with Coupled Pressure and Temperature Swing Adsorption for Smart Chiller</td>
						<td >3</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >25</td>
						<td >2019-2020</td>
						<td >Developing a novel twin-fluid atomizer for energy efficient spray drying of high viscosity liquids</td>
						<td >3</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >26</td>
						<td >2019-2020</td>
						<td >A Novel approach to Wind Turbine Siting and Wind Resource Assessment using Smart Drone based Wind Measurement System</td>
						<td >3</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >27</td>
						<td >2019-2020</td>
						<td >Abrasive Flow Finishing of Micro to Macro Complex Features</td>
						<td >3</td>
						<td >Department of Science and Technology</td>
					</tr>
					<tr>
						<td >28</td>
						<td >2019-2020</td>
						<td >A Non-Newtonian Fluid Model for the dissipation rate of interfacial waves</td>
						<td >2</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >29</td>
						<td >2019-2020</td>
						<td >Physics - based digital twin for automotive brakes</td>
						<td >2</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >30</td>
						<td >2019-2020</td>
						<td >Nano-Finishing of Complex 3-DPrinted Metal and Ceramic Components Using Polymer Rheological Abrasive Medium</td>
						<td >3</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >31</td>
						<td >2019-2020</td>
						<td >Failure envelopes generation for Uni-directional Composite plies / laminates using micro-scale strain and damage analysis: An experimental and numerical study</td>
						<td >2</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >32</td>
						<td >2019-2020</td>
						<td >Regression Models for Doubly Inflated Multivariate Count Data using Copula</td>
						<td >2</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >33</td>
						<td >2019-2020</td>
						<td >Innovation in Science Pursuit for Inspired Research (INSPIRE) Faculty Award</td>
						<td >5</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >34</td>
						<td >2019-2020</td>
						<td >Developing a design basis for cold formed steel wall panels under seismic loading</td>
						<td >3</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >35</td>
						<td >2019-2020</td>
						<td >A Rayleigh Wave based Technique for near surface damage detection in concrete structures through application of non-contact based sensing</td>
						<td >2</td>
						<td >CSIR-Council of Scientific &amp; Industrial Research</td>
					</tr>
					<tr>
						<td >36</td>
						<td >2019-2020</td>
						<td >Production of a nanocomposite sealant from aquatic - derived waste materials</td>
						<td >2</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >37</td>
						<td >2019-2020</td>
						<td >Interactive Desktop Tool for Nonstationary Internsity-Duration-Frequency Curves under Climate Change</td>
						<td >2</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >38</td>
						<td >2019-2020</td>
						<td >"Accessing Householdes" - Preference for Energyy Efficient Appliances in Bengaluru City, India: Internalities, Externalities and Social Norms"</td>
						<td >2</td>
						<td >Indian Council of Social Science Research-ICSSR</td>
					</tr>
					<tr>
						<td >39</td>
						<td >2019-2020</td>
						<td >Panian School of Grammar: A seat of Modern Linguistics and (Post) Structural Poetics</td>
						<td >2</td>
						<td >Indian Council of Social Science Research-ICSSR</td>
					</tr>
					<tr>
						<td >40</td>
						<td >2019-2020</td>
						<td >Folk Media and Identity Construction: Production and Dissemination in Second Phase Telangana Movement</td>
						<td >2</td>
						<td >Indian Council of Social Science Research-ICSSR</td>
					</tr>
					<tr>
						<td >41</td>
						<td >2019-2020</td>
						<td >Efficient distributed computation of massive data</td>
						<td >5</td>
						<td >Department of Science and Technology</td>
					</tr>
					<tr>
						<td >42</td>
						<td >2019-2020</td>
						<td >Automated Detection and Classification of Traumatic Brain Injuries in Head CT images</td>
						<td >2</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >43</td>
						<td >2019-2020</td>
						<td >Coexistence of LTE - Unlicensed and WiFi: Theory and Practice</td>
						<td >2</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >44</td>
						<td >2019-2020</td>
						<td >A high accuracy digitizer for calibration of instrument transformers</td>
						<td >2</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >45</td>
						<td >2019-2020</td>
						<td >A novel scheme to cool the translational as well as internal degrees of freedom of any molecular ion beam</td>
						<td >3</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >46</td>
						<td >2019-2020</td>
						<td >Attosecond spectroscopy as a probe of electron correlation in small polyatomics</td>
						<td >2</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >47</td>
						<td >2019-2020</td>
						<td >Intelligent Test and Reliability Architecture for Extreme Low-power loT Sensor Nodes</td>
						<td >3</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >48</td>
						<td >2019-2020</td>
						<td >Deep learning algorithms for molecular structural data analysis with applications in drug discovery and bioinformatics</td>
						<td >2</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >49</td>
						<td >2019-2020</td>
						<td >A Scalable Secure Architecture Model for Privacy and Performance in IoT</td>
						<td >3</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >50</td>
						<td >2019-2020</td>
						<td >JC Bose Fellowship Award</td>
						<td >6</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >51</td>
						<td >2019-2020</td>
						<td >Impact of Agricultural Interventions on Farmers Wellbeing: Evidences from Semi-Arid Regions of Rural India</td>
						<td >2</td>
						<td >Indian Council of Social Science Research-ICSSR</td>
					</tr>
					<tr>
						<td >52</td>
						<td >2019-2020</td>
						<td >Percolation Properties of Next Generation Multi-Hop Networks</td>
						<td >3</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >53</td>
						<td >2020-2021</td>
						<td >Detoxification of Arsenic Compounds: Enzyme Mimetic Studies to Understand the Methylation of Arsenic by Ar(III) S-adenosylmethione (SAM) Methyltransferase (AS3MT)</td>
						<td >3</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >54</td>
						<td >2020-2021</td>
						<td >Development of a methodological approach to Incorporate the Effect of Vehicle Type in IRC: 37-2018 Performance prediction models</td>
						<td >3</td>
						<td >National Highways Authority of India</td>
					</tr>
					<tr>
						<td >55</td>
						<td >2020-2021</td>
						<td >Development of a Portable Optical Cavity Sterilization Unit</td>
						<td >1</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >56</td>
						<td >2020-2021</td>
						<td >Feasibility studies of Abrasive Flow Machining of Additive Manufactured Typical Wing Body Wind Tunnel Model</td>
						<td >1</td>
						<td >Defence Research and Development Organisation(DRDO)</td>
					</tr>
					<tr>
						<td >57</td>
						<td >2020-2021</td>
						<td >Development of Energy efficient twin-fluidatomizer for effective post combustion CO2 and Nox removal</td>
						<td >3</td>
						<td >Department of Science and Technology</td>
					</tr>
					<tr>
						<td >58</td>
						<td >2020-2021</td>
						<td >Development of case studies on Covid 19</td>
						<td >1</td>
						<td >Institute of Global Environmental Strategies. Japan</td>
					</tr>
					<tr>
						<td >59</td>
						<td >2020-2021</td>
						<td >Physical Layer Secrecy for IoT Networks with Heterogeneous traffic</td>
						<td >3</td>
						<td >Department of Science and Technology</td>
					</tr>
					<tr>
						<td >60</td>
						<td >2020-2021</td>
						<td >Development of a portable atomic frequency standard based on Coherent Population trapping (CPT) for quantum technology applications</td>
						<td >2</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >61</td>
						<td >2020-2021</td>
						<td >Data Driven Automated Diagnosis of Cyber Physical Failures of Smart Grid Assets</td>
						<td >2</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >62</td>
						<td >2020-2021</td>
						<td >Ultra-Reliable Machine to Machine Communication with Short Packets for Mission Critical Applications</td>
						<td >2</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >63</td>
						<td >2020-2021</td>
						<td >Guar-Gum based Novel Biodegradable Abrasive Rheological Medium for Finishing of Drug Eluting Stents using Abrasive Flow Finishing Process</td>
						<td >1</td>
						<td >Biotechnology Industry research assistance council (BIRAC)</td>
					</tr>
					<tr>
						<td >64</td>
						<td >2020-2021</td>
						<td >Development of a new generation reusable antimicrobial N95 respirator</td>
						<td >1</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >65</td>
						<td >2020-2021</td>
						<td >Information Theoretic Limits of Secure Communication for Cache Aided Wireless Networks-Research Grant</td>
						<td >3</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >66</td>
						<td >2020-2021</td>
						<td >Grain boundary-induced melting and martensitic transformation: Phase field study</td>
						<td >2</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >67</td>
						<td >2020-2021</td>
						<td >Metallaphotoredox Catalysis for Sustainable Difluoromethylation</td>
						<td >2</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >68</td>
						<td >2020-2021</td>
						<td >Opinion dynamics in social networks with cooperative-competitive interactions</td>
						<td >2</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >69</td>
						<td >2020-2021</td>
						<td >Accelerated carbonation of muncipal solid waste and industrial byproducts for CO2 sequestration-scope for climate change mitigation</td>
						<td >3</td>
						<td >Department of Science and Technology</td>
					</tr>
					<tr>
						<td >70</td>
						<td >2020-2021</td>
						<td >Antimicrobial Peptide Graphene decorated anti biofouling Reverse Osmosis RO membranes for desalination and water recycling</td>
						<td >3</td>
						<td >Department of Science and Technology</td>
					</tr>
					<tr>
						<td >71</td>
						<td >2020-2021</td>
						<td >Lateral movement of vehicles on Urban roads in disordered Traffic: Characterization , Evaluation and Modeling</td>
						<td >3</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >72</td>
						<td >2020-2021</td>
						<td >Development of organocatalytic heterogeneous catalysis and applications towards the synthesis of templates mimicking bioactive compounds</td>
						<td >5</td>
						<td >Department of Science and Technology</td>
					</tr>
					<tr>
						<td >73</td>
						<td >2020-2021</td>
						<td >Fluctuations in Single-molecule Biophysical Processes: Dynamics and Energetics</td>
						<td >5</td>
						<td >Department of Science and Technology</td>
					</tr>
					<tr>
						<td >74</td>
						<td >2020-2021</td>
						<td >Computational Homogenization and Optimization of Auxetic Chiral Structures for Impact Applications</td>
						<td >3</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >75</td>
						<td >2020-2021</td>
						<td >Locking &amp; mutual synchronization of spin torque oscillators by magneto elastic coupling</td>
						<td >3</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >76</td>
						<td >2020-2021</td>
						<td >Smart manufacturing platform for hybrid tandem wire arc additive manufacturing process</td>
						<td >3</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >77</td>
						<td >2020-2021</td>
						<td >Geosynthetic Reinforced Soil Walls and Abutments for High Speed Railway System</td>
						<td >1</td>
						<td >HSR Innovation Centre Trust</td>
					</tr>
					<tr>
						<td >78</td>
						<td >2020-2021</td>
						<td >Understanding and addressing systemic risks behind the socio-economic impacts of Covid-19 in India and Japan: Developing a roadmap for a resilient and sustainable future.</td>
						<td >1</td>
						<td >Indian Institute of Social Science Research-IISSR</td>
					</tr>
					<tr>
						<td >79</td>
						<td >2020-2021</td>
						<td >Control theoretic framework for auto-scaling and load-balancing computing nodes hosting distributed algorithms for robot-vision applications</td>
						<td >3</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
      				<tr>
						<td >80</td>
						<td >2021-2022</td>
						<td >Design of WiFi Test bed for
Demonstrating LTE-Unlicensed</td>
						<td >2</td>
						<td >Arista Networks India
Pvt Ltd</td>
					</tr>
      				<tr>
						<td >81</td>
						<td >2021-2022</td>
						<td >Modelling of Stormwater Network
using Mike + Urban</td>
						<td >1</td>
						<td >DHI (India) Water &amp;
Environment Pvt Ltd</td>
					</tr>
      				<tr>
						<td >82</td>
						<td >2021-2022</td>
						<td >Estimation of Embodied Energy and Carbon Footprint Performance Indicators of Highway Infrastructure</td>
						<td >3</td>
						<td >Aarvee Associates</td>
					</tr>
					<tr>
						<td >83</td>
						<td >2021-2022</td>
						<td >PM FME CIC</td>
						<td >5</td>
						<td >Andhra Pradesh Food Processing Society</td>
					</tr>
					<tr>
						<td >84</td>
						<td >2021-2022</td>
						<td >Development of Encapsulated Asphalt-Rubber PAVEment (EARPAVE) Product for Road Applications</td>
						<td >2</td>
						<td >Petroleum Conservation Research Association (PCRA)</td>
					</tr>
					<tr>
						<td >85</td>
						<td >2021-2022</td>
						<td >Modelling Forest Phenological Parameters from Time Series Remote Sensing Data</td>
						<td >3</td>
						<td >Space Applications Centre, ISRO, Ahmedabad, Gujarat</td>
					</tr>
					<tr>
						<td >86</td>
						<td >2021-2022</td>
						<td >National facility for Accelerated
Testing of Pavements and Vehicle Dynamics (NATPaVeD)</td>
						<td >3</td>
						<td >Ministry of Road Transport &amp; Highways (MoRTH)</td>
					</tr>
					<tr>
						<td >87</td>
						<td >2021-2022</td>
						<td >Theoretical spectroscopic investigation of the microscopic origin of chaotropicity and kosmotropicity of osmolytes</td>
						<td >3</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >88</td>
						<td >2021-2022</td>
						<td >Process topology based computational methods for sensor and actuator placement in large scale systems</td>
						<td >2</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >89</td>
						<td >2021-2022</td>
						<td >Many-body quantum engines</td>
						<td >2</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >90</td>
						<td >2021-2022</td>
						<td >Functionally Graded Polymer Derived Ceramic Surface Nano Composites using Solid-State Additive Friction-Stir Manufacturing (AFSM)</td>
						<td >2</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >91</td>
						<td >2021-2022</td>
						<td >Finishing of 3D Printed High Aspect Ratio Complex Internal
Conformal Cooling Channels using Economic Polymer Rheological
Abrasive Semisolid Medium</td>
						<td >3</td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
					<tr>
						<td >92</td>
						<td >2021-2022</td>
						<td >Cyber Physical Modelling and Detection of Cyber Attacks in a
WADC for Smart Grids</td>
						<td >1</td>
						<td >Central Power Research Institute</td>
					</tr>
      <tr>
						<td >93</td>
						<td >2021-2022</td>
						<td >Teachers associateship for research excellence (TARE)</td>
						<td >3 </td>
						<td >Science and Engineering Research Board- SERB</td>
					</tr>
      <tr>
						<td >94</td>
						<td >2021-2022</td>
						<td >Development of a deterministic single photon source for quantum networking applications </td>
						<td >2</td>
						<td >I-HUB Quantum technology foundation </td>
					</tr>
      <tr>
						<td >95</td>
						<td >2021-2022</td>
						<td >Inner cohomology of GL_n </td>
						<td >3 </td>
						<td >Science and Engineering Research Board- SERB </td>
					</tr>
      <tr>
						<td >96</td>
						<td >2021-2022</td>
						<td >Mechanical and microstructural behaviour of laser based direct energy deposited and wire arc additive manufactured Ti-6AL-4V Components</td>
						<td >3</td>
						<td >Aeronautics R&amp;D Board (ARDB) </td>
					</tr>
      <tr>
						<td >97</td>
						<td >2021-2022</td>
						<td >Theoretical Investigation of Bioinspired Channel Based Membrane for Water Purification </td>
						<td >3</td>
						<td >Science and Engineering Research Board- SERB </td>
					</tr>
      <tr>
						<td >98</td>
						<td >2021-2022</td>
						<td >Design and Development of Disaster Response Dashboard for India </td>
						<td >3 </td>
						<td >Facebook India online service. </td>
					</tr>
      <tr>
						<td >99</td>
						<td >2021-2022</td>
						<td >Track and Trigger: ultra soundresponsive mesoporous Mn@Silica nanocapsules for delivery and therapeutic microRNA's and p53 supplemented suidice genes to glioblastoma </td>
						<td >5</td>
						<td >Department of Biotechnology </td>
					</tr>
      <tr>
						<td >100</td>
						<td >2021-2022</td>
						<td >Towards development of fluorophores of predictable fluorescence: A comprehensive investigation of fluorescence characteristics of fluorescein </td>
						<td >3 </td>
						<td >Science and Engineering Research Board- SERB </td>
					</tr>
      <tr>
						<td >101</td>
						<td >2021-2022</td>
						<td >The Analysis and simulation of beam-wave interaction for dual mode dual harmonic gyrotrons with the design of specific modules</td>
						<td >3</td>
						<td > Science and Engineering Research Board- SERB</td>
					</tr>
      <tr>
						<td >102</td>
						<td >2021-2022</td>
						<td >Machine Learning in Mechanics: Current Status and Future Prospects </td>
						<td >1</td>
						<td >Machine Learning in Mechanics: Current Status and Future Prospects </td>
					</tr>
      <tr>
						<td >103</td>
						<td >2022-2023</td>
						<td >A Virtual AR/VR Museum for Science and Technology Literacy </td>
						<td >2</td>
						<td >Department of Science &amp; Technology </td>
					</tr>
      <tr>
						<td >104</td>
						<td >2022-2023</td>
						<td >Material and process development for additive manufacturing and postprocessing of tools made of modified hot work tool steel (ModAMtool) </td>
						<td >3 </td>
						<td >Department of Science and Technology</td>
					</tr>
      <tr>
						<td >105</td>
						<td >2022-2023</td>
						<td >Development of Ultra-HighPerformance Concretes (UHPCs) for Road/Bridge Infrastructure in Urban Areas</td>
						<td >2</td>
						<td >Kerala Highway Research Institute </td>
					</tr>
      <tr>
						<td >106</td>
						<td >2022-2023</td>
						<td >Design, Development, Testing and Commercialization of Porous Radiant Burners for Domestic Cooking and Industrial Applications </td>
						<td >3</td>
						<td >Indian National Academy of Engineering </td>
					</tr>
      <tr>
						<td >107</td>
						<td >2022-2023</td>
						<td >Optimal protocols beyond adiabaticity </td>
						<td >4 </td>
						<td >Department of Science and Technology </td>
					</tr>
      <tr>
						<td >108</td>
						<td >2022-2023</td>
						<td >Chanakya Fellowship </td>
						<td >1 </td>
						<td >IIT Tirupati Navavishkar I-Hub Foundation</td>
					</tr>
      <tr>
						<td >109</td>
						<td >2022-2023</td>
						<td >Polyoxovanadate Decorated Supramolecular Architectures for Energy Storage Application </td>
						<td >2</td>
						<td >Science and Engineering Research Board- SERB </td>
					</tr>
      <tr>
						<td >110</td>
						<td >2022-2023</td>
						<td >The Cyclopiane Diterpenes: Total Syntheses of Conidiogenone B, Conidiogenone, and Conidiogenol </td>
						<td >2</td>
						<td >Science and Engineering Research Board- SERB </td>
					</tr>
      <tr>
						<td >111</td>
						<td >2022-2023</td>
						<td >Carbon less alternative fuels for transportation </td>
						<td >5 </td>
						<td >Science and Engineering Research Board- SERB </td>
					</tr>
      <tr>
						<td >112</td>
						<td >2022-2023</td>
						<td >The quantum complexity of dualunitary and Bernoulli quantum many-body circuits </td>
						<td >2</td>
						<td >Science and Engineering Research Board- SERB </td>
					</tr>
      <tr>
						<td >113</td>
						<td >2022-2023</td>
						<td >Asymmetric Synthesis of Alkyl Amines by Enantioselective Umpolung Nickel Catalysis of Imines </td>
						<td >2</td>
						<td >Science and Engineering Research Board- SERB </td>
					</tr>
      <tr>
						<td >114</td>
						<td >2022-2023</td> 
						<td >DST-IIT Bombay Energy Storage Platform on Hydrogen </td>
						<td >2</td>
						<td >Department of Science and Technology </td>
					</tr>
      <tr>
						<td >115</td>
						<td >2022-2023</td>
						<td >Synthetic Studies Towards Glycoconjugate Vaccine Against Antimicrobial Resistant Enterococcus faecium </td>
						<td >2</td>
						<td >Science and Engineering Research Board- SERB </td>
					</tr>
				</tbody></table>
                
                
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="second">

                                    <table className="table table-striped">
<thead>
  <tr>
  <td>Project Title
</td>
  
  <td>Funding Agency
</td>
  <td>Faculty Name
</td>
  <td>Financial Year
</td>
  </tr>
  </thead>
<tbody><tr>
  <td>Technology Innovation Hub- Precision technologies

</td>
  <td>National Mission on Inter-disciplinary Cyber Physical Systems-Department of Science &amp; Technology

</td>
  <td>Prof. K N  Satyanarayana

</td>
  <td>2020-2021
</td>
  
  </tr>
</tbody></table>

                                    </Tab.Pane>
                                </Tab.Content>
                                </Col>
                            </Row>
                            </Tab.Container>
                    </Col>

                    </Row>
                </div>
            </section>
        </>
    );
}

export default Main;